import get from 'transmute/get';
import { AGENT_ID, AGENT_TYPE } from '../constants/keyPaths';
export const getAgentId = agentLocator => {
  return get(AGENT_ID, agentLocator);
};
export const getAgentType = agentLocator => {
  return get(AGENT_TYPE, agentLocator);
};